import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";

/**
 * Guard to ensure the `:id` route param is a whole number before the page
 * loads, so a mistyped url never reaches the api as `NaN`.
 */
export function numericIdGuard(redirectTo: string, param = "id"): CanActivateFn {
  return (route): boolean | UrlTree => {
    const router = inject(Router);
    const id = route.paramMap.get(param);

    if (id !== null && /^\d+$/.test(id)) return true;
    return router.createUrlTree([redirectTo]);
  };
}
